import { useState, useEffect } from "react";
import { resetPassword } from "../../utils";
import { InputComp, Button } from "../../components";

const ResetLinkModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isInvalid, setIsInvalid] = useState(false);

  const handleResetPassword = async () => {
    if (!email) {
      setError("Please enter your email address.");
      setTimeout(() => setError(""), 3000);
      return;
    }

    const isSuccess = await resetPassword(email);
    onClose();
    if (!isSuccess) {
      setError("Failed to send reset password email. Please try again.");
      setTimeout(() => setError(""), 3000);
    }
  };

  const handleInputChange = (key, value) => {
    if (key === "email") {
      const regex = /^[^\s@]+@exeonic\.com$/;
      setIsInvalid(!regex.test(value));

      if (!regex.test(value)) {
        setTimeout(() => setIsInvalid(false), 3000);
      }
    }
    setEmail(value);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const modal = document.getElementById("modalContent");
      if (modal && !modal.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div
        id="modalContent"
        className="bg-white p-6 rounded-lg shadow-lg w-96 py-6"
      >
        <h2 className="text-2xl font-semibold mb-4">Reset Your Password</h2>
        <InputComp
          label="Email"
          placeHolder="Enter your email"
          value={email}
          handleChange={handleInputChange}
          type="text"
          inputKey="email"
        />
        {isInvalid && <p className="text-red-500">Invalid email format</p>}
        {error && <p className="text-red-500">{error}</p>}

        <div className="flex justify-end space-x-2 mt-5">
          <button
            className="px-4 py-2 bg-color-4 rounded text-white"
            onClick={onClose}
          >
            No
          </button>
          <button
            className="px-4 py-2 bg-primary text-white rounded"
            onClick={handleResetPassword}
          >
            Reset Password
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetLinkModal;
